// extracted by mini-css-extract-plugin
export default {"dashboard-card-container":"MainApp_organisms_Dashboard_Card_dashboard-card-container__38+YZ"};